<div class="card card-custom gutter-b">
    <!--Header-->
    <div class="card-header">

        <!--Title - Edit/Create-->
        <div class="card-title">
            <h3 class="card-label">
                <ng-container *ngIf="procedure">{{ id ? "Edit" : "New" }} procedure</ng-container>
            </h3>
        </div>

        <!--Actions-->
        <div class="card-toolbar row">
            <button class="btn-default btn-go-back" routerLink="/procedures/list">
                <span class="fa fa-arrow-left"></span>
            </button>
        </div>
    </div>


    <div class="card-body p-0 m-0">

        <!--Form Alert Message-->
        <div *ngIf="formSent">
            <div class="col-12 m-0 py-0 px-9">
                <app-form-message *ngIf="formSent" [success]="formResponse"
                                  [customErrorMessage]="errorMsg" [customSuccessMessage]="successMsg">
                </app-form-message>
            </div>
            <div class="border-bottom"></div>
        </div>


        <div *ngIf="procedure">
            <form class="col-lg-12 p-0 m-0 row" [formGroup]="formGroup">

                <!--Left Side-->
                <div class="col-lg-8 m-0 p-0 px-12 py-6">

                    <!--Title-->
                    <div class="col-12 m-0 p-0 py-3 form-group">
                        <label for="title" class="text-label" translate="DIRECTIVES.TITLE"></label>
                        <input type="text"
                               id="title"
                               class="form-control form-layout"
                               name="title"
                               formControlName="title"
                               [class.is-invalid]="isControlInvalid('title')">
                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'title')">
                            This field is required!
                        </div>
                    </div>

                    <!--Category-->
                    <div class="col-12 m-0 p-0 py-3 form-group">
                        <label for="categories" class="text-label" translate="DIRECTIVES.CATEGORIES"></label>
                        <ng-select2 class="form-layout"
                                    [data]="procedureCategories"
                                    [options]="multipleOptions"
                                    id="categories"
                                    formControlName="categories"
                                    [class.is-invalid]="isControlInvalid('categories')">
                        </ng-select2>
                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'categories')">
                            This field is required!
                        </div>
                    </div>

                    <!--Description-->
                    <div class="col-12 m-0 p-0 py-3 form-group">
                        <label for="description" class="text-label" translate="DIRECTIVES.DESCRIPTION"></label>
                        <angular-editor [config]="config"
                                        formControlName="description"
                                        id="description">
                        </angular-editor>
                    </div>

                </div>

                <!--Right Side-->
                <div class="col-lg-4 m-0 p-0 px-12 py-6 border-left">

                    <!--Status-->
                    <div class="form-group col-12 m-0 p-0 py-3">
                        <label for="status" class="text-label" translate="DIRECTIVES.STATUS"></label>
                        <select class="form-control form-layout minimal"
                                name="status"
                                id="status"
                                formControlName="status">
                            <option value="Draft">Draft</option>
                            <option value="Published">Published</option>
                            <option value="Archived">Archived</option>
                        </select>
                    </div>

                    <!--Attachments-->
                    <div class="col-12 p-0 my-3">
                        <div class="custom-padding">
                            <app-add-attachments moduleName="procedure"></app-add-attachments>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    </div>
    <!--Footer-->
    <div class="card-footer d-flex justify-content-end">
        <button type="submit" class="btn-default btn-green flex-row-reverse" (click)="save()"
                translate="GENERAL.SAVE">
            <span class="fa fa-save mr-3"></span>
        </button>
    </div>
</div>
